__turbopack_context__.v({
  "favoritesButton": "MobileActions-module-scss-module__LBosGW__favoritesButton",
  "searchExpand": "MobileActions-module-scss-module__LBosGW__searchExpand",
  "searchExpandOtherActions": "MobileActions-module-scss-module__LBosGW__searchExpandOtherActions",
  "searchIconBorder": "MobileActions-module-scss-module__LBosGW__searchIconBorder",
  "searchTermPadding": "MobileActions-module-scss-module__LBosGW__searchTermPadding",
  "sticky": "MobileActions-module-scss-module__LBosGW__sticky",
});
